module.exports = __webpack_public_path__ + "static/media/shaker_left.7a4833d6.png";